/**
 * ComplianceLegend — Bottom remark showing what the blue-highlighted fields mean.
 * "🔵 = Compliance-certified data (SS 626:2024)"
 */

interface ComplianceLegendProps {
  compact?: boolean;
}

export function ComplianceLegend({ compact }: ComplianceLegendProps) {
  if (compact) {
    return (
      <div className="flex items-center gap-1.5 text-[10px] text-muted-foreground mt-2">
        <span className="inline-block w-2.5 h-2.5 rounded border border-blue-300 shrink-0" />
        TR128 Compliance data
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-xs text-muted-foreground border-t pt-2 mt-3">
      <span className="inline-block w-3 h-3 rounded border border-blue-300 shrink-0" />
      <span>
        <span className="inline-block w-4 h-3 border border-blue-300 rounded-sm mr-1" />
        = TR128 Compliance data (SS 626:2024)
      </span>
    </div>
  );
}
